import api from "../axios";

export const CustomerStatus = () => {
  const data = api.get("/customer/status");
  return data;
};
